import RecaptchaModal from '@/components/RecaptchaModal/RecaptchaModal';
import Vue from 'vue';

// eslint-disable-next-line
const axios = require('axios');

let modal503;

function modal503Factory(err) {
  if (err.rcRetries > 1) {
    throw new Error(`Still getting 503 after ${err.rcRetries} attempts.`);
  }

  const modalContainer = document.createElement('div');

  document.body.appendChild(modalContainer);

  const view = new Vue({
    ...RecaptchaModal,
    data() {
      return {
        request: err.config,
        recaptchaKey: window.recaptchaKey || null,
      };
    },
  });

  view.$mount(modalContainer);

  return view;
}

export default function () {
  axios.interceptors.response.use(
    (res) => res,
    async (err) => {
      if (err.response && err.response.status === 503) {
        if (!modal503) {
          modal503 = modal503Factory(err);
        }
        const token = await modal503.challenge();
        if (token) {
          // eslint-disable-next-line no-param-reassign
          err.config.headers['X-Recaptcha'] = token;
          if (!err.config.rcRetires) {
            // eslint-disable-next-line no-param-reassign
            err.config.rcRetries = 1;
          }
          // eslint-disable-next-line no-param-reassign,no-plusplus
          err.config.rcRetries++;

          return axios.request(err.config);
        }

        throw new Error('Captcha validation unexpectedly returned no token');
      }

      return Promise.reject(err);
    },
  );
}
